/**
 * @fileOverview This file contains the implementation of the AcquireScreen.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Stack, Typography, Button } from "@mui/material";
import React, { useState } from "react";
import "../scss/Components/_acquirescreen.scss";
import durandalAcquire from "../media/Images/durandalAcquire.svg";
import axios from "axios";
import { GlobalVariables } from "../globalVar";
import moment from "moment";
import AcquireDialog from "./Variety/AcquireDialog";
import { useTranslationHook } from "../hooks/UseTranslationHook";

function AcquireScreen() {
  const {
    mainAcquireStr,
    bodyAcquireStr,
    onlineAcquireMethodStr,
    commercialAcquireMethodStr,
  } = useTranslationHook();

  const [dialogOpen, setDialogOpen] = useState(false);

  const currUserId = localStorage.getItem("currUserLogged");
  var datetime = moment().toISOString(true);

  /**
   * Handles the click event when contacting the commercial team.
   * Sends a request to acquireViaCommercial API and opens a dialog on successful response.
   * @async
   * @function
   * @returns {Promise<void>}
   */
  const handleContactClick = async () => {
    try {
      const response = await axios.post(
        `${GlobalVariables.getURL()}acquireViaCommercial/${currUserId}`,
        {
          datetime,
        }, {
          headers: {
            'Authorization': 'bearer ' + localStorage.getItem('token')
          }
        }
      );

      if (response.status === 200) {
        setDialogOpen(true);
      }
    } catch (error) {
      // Log any errors that occur during the request
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  /**
   * Closes the dialog and navigates to the "/dashboard" route.
   * @function
   * @returns {void}
   */
  const handleCloseDialog = () => {
    setDialogOpen(false);
    window.close();
  };

  return (
    <div className="acquire-screen">
      <div className="acquire-image-container">
        <img
          src={durandalAcquire}
          alt="Acquire Durandal"
          className="acquire-image"
        />
      </div>
      <div className="acquire-main-container">
        <Typography variant="h3" component="h1" gutterBottom>
          {mainAcquireStr}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {bodyAcquireStr}
        </Typography>
        <Stack
          spacing={2}
          direction="column"
          className="acquire-btns-container"
        >
          <Button variant="contained" disabled>
            {onlineAcquireMethodStr}
          </Button>
          <Button
            variant="contained"
            className="commercial-team-btn"
            onClick={handleContactClick}
            disabled={dialogOpen}
          >
            {commercialAcquireMethodStr}
          </Button>
        </Stack>
      </div>
      <AcquireDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  );
}

export default AcquireScreen;
